export default __webpack_public_path__ + "static/media/electrolysis.2f485d23.svg";